(() => {
  const orderTarget = document.querySelector('#shopify-order');
  document.querySelectorAll('[data-order-jump]').forEach((link) => {
    link.addEventListener('click', (event) => {
      if (!orderTarget) return;
      event.preventDefault();
      orderTarget.scrollIntoView({ behavior: 'smooth', block: 'start' });
      window.setTimeout(() => {
        const first = orderTarget.querySelector('select, input, button');
        if (first) first.focus({ preventScroll: true });
      }, 500);
    });
  });

  const form = document.querySelector('[data-direct-checkout]');
  if (!form) return;
  const submit = form.querySelector('[type="submit"]');
  const status = form.querySelector('.order-form__status');
  form.addEventListener('submit', async (event) => {
    event.preventDefault();
    if (!submit || submit.disabled) return;
    submit.disabled = true;
    const original = submit.innerHTML;
    submit.querySelector('span:first-child').textContent = 'جارٍ تجهيز الدفع…';
    if (status) status.textContent = '';
    try {
      const response = await fetch(form.action, {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: new FormData(form),
        credentials: 'same-origin'
      });
      if (!response.ok) throw new Error('cart_add_failed');
      window.location.assign('/checkout');
    } catch (error) {
      submit.disabled = false;
      submit.innerHTML = original;
      if (status) status.textContent = 'تعذّر تجهيز الدفع. حاول مجددًا.';
    }
  });
})();
